import React from 'react'
import MemberMudriseen from '../../member/MemberMudaris/MemberMudriseen'

const MemberMudariseenReport = () => {
  return (
     <MemberMudriseen renderPage={"reports"} />
  )
}

export default MemberMudariseenReport